/* eslint-disable no-underscore-dangle */
// https://github.com/google-map-react/google-map-react
const DEFAULT_URL = `https://maps.googleapis.com`;
const API_PATH = '/maps/api/js?';

let $script_ = null;

let loadPromise_: Promise<typeof google.maps>;

declare global {
  interface Window {
    _$_google_map_initialize_$_: any; // eslint-disable-line camelcase
  }
}

export const isGoogleMapsLoaded = () =>
  window.google !== undefined && window.google.maps !== undefined;

export default (apiKey?: string) => {
  if (!apiKey) {
    throw new Error('Api key cannot be empty');
  }
  if ($script_ === null) {
    $script_ = require('scriptjs'); // eslint-disable-line
  }

  if (loadPromise_) {
    return loadPromise_;
  }

  loadPromise_ = new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      reject(new Error('google map cannot be loaded outside browser env'));
      return;
    }

    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    if (typeof window._$_google_map_initialize_$_ !== 'undefined') {
      reject(new Error('google map initialization error'));
    }

    window._$_google_map_initialize_$_ = () => {
      delete window._$_google_map_initialize_$_;
      resolve(window.google.maps);
    };
    const params = `key=${apiKey}&libraries=places&callback=_$_google_map_initialize_$_`;

    // @ts-expect-error possible null object
    $script_(`${DEFAULT_URL}${API_PATH}${params}`, () => {
      if (typeof window.google === 'undefined') {
        reject(new Error('google map initialization error (not loaded)'));
      } else {
        resolve(window.google.maps);
      }
    });
  });

  return loadPromise_;
};
